import React from 'react'
import {IMG_URL} from '../utils/Constants'
import Detailphoto from './Detailphoto'
import {useDispatch, useSelector} from 'react-redux'
import {toggleshowDetails} from '../utils/detailsSlice'
import {togglePopUp} from '../utils/detailsSlice'
export const DetailsContainer = () => {
      const movieDetails = useSelector((store)=> store.details.MovieDetails);
      console.log(movieDetails)
      const dispatch = useDispatch(); 
      
      const youtubePopUp = () => {
        dispatch(togglePopUp())
      }

      const backToHome = () =>{
        dispatch(toggleshowDetails())
      }
    return (
      <>
        <div className='flex flex-col w-screen md:w-[700px] p-20 '>      
        <button type="button" class="text-white bg-gradient-to-br from-pink-500 to-orange-400 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-pink-200 dark:focus:ring-pink-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2" onClick={backToHome}>Back</button>
                <h1 className='md:text-6xl text-xl font-medium pb-6 pt-6 md:font-extrabold bg-gradient-to-r from-red-700 via-yellow-600 to-fuchsia-700 inline-block text-transparent bg-clip-text'>{movieDetails?.original_title}</h1>
                <p  className=' text-white p-1 pb-5 italic ' >"{movieDetails?.tagline}"</p>
                <img className="w-60 pb-4" src= {IMG_URL + movieDetails?.poster_path} alt="Bg-img" /> 
                <button type="button" class="text-white bg-gradient-to-r from-purple-500 to-pink-500 hover:bg-gradient-to-l focus:ring-4 focus:outline-none focus:ring-purple-200 dark:focus:ring-purple-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2" onClick={youtubePopUp}>Play</button>        
                <div className='backdrop-blur-xl p-5'>
                <p className='text-red-400  pt-5 font-bold  text-2xl '>Overview:</p>
                <p className='text-white text-base md:text-base w-[200px]  font-semibold md:w-[500px] py-1 pb-2'>{movieDetails?.overview}</p>
                
                <Detailphoto />
          </div>
        </div>
      </>
    
  )
}
